import StyledText from "@ecp-boxes/shared/styleElements/StyledText/StyledText";
import { useBoxCartStepTwoExtended } from "../BoxCartStepTwoExtended/context/BoxCartStepTwoExtended.context";
import { IBoxCartStepTwoExtendedProps } from "../BoxCartStepTwoExtended/BoxCartStepTwoExtended.types";
import { useBoxContext } from "@ecp-boxes/structure/Contexts/BoxContext";
import { isNotEmptyMessage } from "@ecp-boxes/helpers/isNotEmptyMessage";
import { TSectionValidationLookup } from "../BoxCartStepTwoExtended/hooks/useSectionValidation";

interface ISectionValidatorProps {
  section: keyof TSectionValidationLookup;
}

const SectionValidator = ({ section }: ISectionValidatorProps) => {
  const { sectionValidationLookup, purchaseButtonTimestamp } =
    useBoxCartStepTwoExtended();
  const { messages, settings } = useBoxContext<IBoxCartStepTwoExtendedProps>();

  const isSectionValid = sectionValidationLookup[section];

  if (
    !purchaseButtonTimestamp ||
    isSectionValid ||
    !isNotEmptyMessage(
      messages[`${section}_validation_error` as keyof typeof messages]
    )
  ) {
    return null;
  }

  return (
    <StyledText
      $settings={{
        font: settings.validation_error_typography,
        text: { color: settings.validation_error_color },
      }}
    >
      {messages[`${section}_validation_error` as keyof typeof messages]}
    </StyledText>
  );
};

export default SectionValidator;
